<script>
import TriviaService from "@/api/services/triviaService";
import {mapMutations, mapState} from "vuex";
import DepService from "@/api/services/depService";

export default {
  computed: {
    ...mapState(['user', 'productId', 'gameState', 'userStats']),
    coinsToDisplay() {
      const coins = parseInt(this.$route.query.coins) || 0;  // ✅ Read from query
      console.log('💰 BonusWin - Coins:', coins);
      return coins;
    }
  },
  methods: {
    ...mapMutations(['setUserStats']),
    async getUserStats() {
      const recordsets = await TriviaService.getUserStats(this.user.msisdn, this.productId, this.user.serviceId);
      this.setUserStats(recordsets?.[0]?.[0])
    },
    async addFunds(amount) {
      try {
        await DepService.addFunds(
            this.user.msisdn,
            this.productId,
            7,
            1,
            amount,
            this.gameState.GameId
        );
        console.log('💰 Halved coins added:', amount);
      } catch (error) {
        console.error('Error adding coins:', error);
      }
    },
    async returnHome() {
      // Add the halved coins
      await this.addFunds(this.coinsToDisplay);

      // Refresh user stats
      await this.getUserStats();

      // Navigate home
      this.$router.push('/');
    }
  },
  // async beforeDestroy() {
  //   await this.getUserStats();
  // }
}
</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12 containerBack">
    <div class="d-flex justify-content-center align-items-center gameOver mt-5">GAME OVER</div>
    <div class="d-flex justify-content-center align-items-center coinDoubled">COINS HALVED</div>
    <div class="d-flex justify-content-center align-items-center mt-5">
      <img src="@/assets/bonusRound/halved-img.png" class="col-10">
    </div>

    <div class="d-flex flex-column">
      <div class="d-flex flex-row justify-content-center">
        <div class="number">+{{ coinsToDisplay }}</div>
        <img src="@/assets/gameplay/coins-large.png" class="col-4 position-relative">
      </div>
      <img src="@/assets/bonusRound/halved-coin-sparkles.png" class="col-6 position-sticky sparkles">
    </div>

    <div class="d-flex flex-column justify-content-center align-items-center  col-12">
      <div class="playButton playText p-3 col-11 text-center" @click="returnHome">Return Home</div>
    </div>

  </div>

</template>


<style scoped>

.containerBack {
  background-color: #F52E2F;
  min-height: 100vh;

}

.playButton {
  background-color: #000000;
  border-radius: 30px;
}

.playText {
  font-weight: 600;
  font-size: 19px;
  color: #FFFFFF;
}

.gameOver {
  font-weight: 600;
  font-size: 42px;
  color: #FFFFFF;
}

.coinDoubled {
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
}

.number {
  font-weight: 700;
  font-size: 67px;
  color: #FFFFFF;

}

.sparkles {
  bottom: 31%;
  left: 7%;
}

</style>